export const getCarBodyType = (bodyTypeCode?: string): string => {
	switch (bodyTypeCode) {
		case 'CV':
			return 'Bestelauto';
		case 'WV':
			return 'Bestelwagen met ramen';
		case 'CA':
			return 'Cabriolet';
		case 'BH':
			return 'Chassis-cabine';
		case 'CC':
			return 'Combi';
		case 'CO':
			return 'Coupé';
		case '_FTS':
			return 'Fiets';
		case 'PV':
			return 'Gesloten bestelwagen';
		case 'VADC':
			return 'Gesloten bestelwagen dub cab';
		case 'HA':
			return 'Hatchback';
		case '_HEF':
			return 'Heftruck';
		case 'MC':
			return 'Micro-auto';
		case 'MM':
			return 'Mini MPV';
		case '_MF':
			return 'Motorfiets';
		case 'FW':
			return 'MPV';
		case 'OC':
			return 'Off-road commercial';
		case 'DS':
			return 'Pick-up';
		case 'PU':
			return 'Pick-up';
		case 'DP':
			return 'Pick-up dubbele cab';
		case 'SA':
			return 'Sedan';
		case '_SPC':
			return 'Speciaal voertuig';
		case 'OD':
			return 'SUV';
		case 'ES':
			return 'Stationwagen';
		case 'TA':
			return 'Targa';
		case '_TRK':
			return 'Trekkerchassis';
		case 'TR':
			return 'Vrachtwagen';
		case '_WRK':
			return 'Werkmateriaal';
		default:
			return '-';
	}
};
